<template>
  <div class="welcome-page">
    <div class="main-infos">
      <div class="greet">{{ greetText }}</div>
      <div class="question">{{ questionText }}</div>
      <div class="bth-group start-btn" style="max-width: 580px;">
        <maf-button :name="'Go to financial education'" :width="290" :bgColor="'-webkit-linear-gradient(left top, rgb(255, 121, 14), rgb(255, 88, 88))'" @actionFunc="goToFinancialEducation"/>
        <maf-button :name="btnText" :width="290" :bgColor="'-webkit-linear-gradient(left top, rgb(48, 35, 174), rgb(200, 109, 215))'" @actionFunc="startApplication"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getViewLoansRemoting, openSurveyByLanguage } from '../../api'
export default {
  name: 'Welcome',
  data() {
    return {
      questionText: 'Looks like you do not have any applications yet. Would you like to start an application today?',
      btnText: 'Start an application'
    };
  },
  methods: {
    async startApplication() {
      const loanErrorPopup = await getViewLoansRemoting(this.userInfo.userId);
      if (loanErrorPopup.isShow) {
        this.$store.commit('SHOW_LOANS_POPUP', loanErrorPopup);
        this.$store.commit('IS_CUSTOM_POPUP_CHANGED', true);
      } else {
        openSurveyByLanguage(this.retProgramEligibilityUrls, this.userInfo.contactId);
      }
      this.$trackEvent('Start application clicked', this.userInfo);
    },

    goToFinancialEducation() {
      if (this.retAdobeLMSUrl && this.retAdobeLMSUrl.indexOf('https') !== -1) {
        window.open(this.retAdobeLMSUrl, '_blank');
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      contactInfo: state => state.contactInfo,
      retAdobeLMSUrl: state => state.retAdobeLMSUrl,
      retProgramEligibilityUrls: state => state.retProgramEligibilityUrls,
    }),
    greetText() {
      return `Welcome, ${this.userInfo.firstName}!`;
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../sass/main.scss';

.welcome-page {
  width: 100%;
  height: 702px;
  @include inline-flex-col;
  background-color: #fff;
  background-image: url('../../assets/home-bg.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-x: center;
  background-position-y: bottom;
  border-radius: 7px;

  @media screen and (max-width: $max-width-phone) {
    background-size: 130%;
    background-position-x: right;
  }

  .main-infos {
    padding: 50px;

    @media screen and (max-width: $max-width-phone) {
      padding: 30px;
    }
  }

  .greet {
    padding-top: 0;
    margin-bottom: 20px;
    font-size: $font-size-largest-more;
    color: $font-color-title;

    @media screen and (max-width: $max-width-phone) {
      font-size: $font-size-larger;
    }
  }

  .question {
    color: $font-color-sub-title;

    @media screen and (max-width: $max-width-phone) {
      font-size: $font-size-base;
    }
  }

  .start-btn {
    padding: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/welcome/Welcome.vue